<main class="address-list-component" [class.adlc-error]="hasError">
	<section class="flex mb-2">
		<div class="w-6 h-6 flex jc-center items-center">
			@if (isRequired) {
				<lbca-icon
					[class.adlc-isTouched]="isTouched"
					class="adlc-light"
					size="small"
					name="lucide:asterisk"
				/>
			}
		</div>
		<div class="h-6 flex items-center">
			<label class="text-sm text-gray-900">{{ labelValue }}</label>
		</div>
	</section>

	<section>
		@for (address of addressList; track address; let index = $index) {
			<div class="mb-4">
				<lbca-address
					(changeData)="changeValue($event, address)"
					[require]="isRequired && index === 0"
					[labeled]="isLabeled"
					(delete)="deleteAddress(address)"
					(validateCallback)="setFieldValidateCallback($event)"
					[displayFields]="displayFields"
					[data]="address"
				></lbca-address>
			</div>
		}
	</section>

	@if (isLabeled && validateRegister()) {
		<section>
			<div (click)="addNewAddress()" class="flex cursor-pointer show trs-eio-600">
				<button class="btn-type-3 btn-primary ml-7">
					<lbca-icon name="lucide:plus" size="small" class="text-gray-100" />
				</button>
				<span class="h-32 flex jc-center ml-12 mt-4 text-sm fc-8">Adicionar novo endereço</span>
			</div>
		</section>
	}
</main>
